<template>
  <v-app>
    <v-main class="login-page">
      <v-container fluid class="pa-0 fill-height">
        <v-row no-gutters class="fill-height">
          <!-- Left Side - Login Form -->
          <v-col cols="12" md="5" class="login-form-side d-flex align-center">
            <div class="form-container">
              <!-- Logo -->
              <!-- <div class="logo-section mb-12">
                <img src="~@/assets/images/logo-full.png" alt="Logo" class="logo-image" />
              </div> -->

              <!-- Sign in heading -->
              <h1 class="text-h4 font-weight-bold mb-10">Sign in</h1>

              <!-- Form -->
              <v-form @submit.prevent="submit" ref="formRef">
                <!-- Email -->
                <div class="mb-6">
                  <label class="field-label mb-2">Email address</label>
                  <v-text-field
                    v-model="form.email"
                    type="email"
                    placeholder="your@example.com"
                    
                    variant="outlined"
                    density="comfortable"
                    required
                    hide-details
                    class="custom-input"
                    bg-color="white"
                  ></v-text-field>
                </div>

                <!-- Password -->
                <div class="mb-4">
                  <div class="d-flex justify-space-between align-center mb-2">
                    <label class="field-label">Password</label>
                    <a href="#" class="forgot-link">Forgot password?</a>
                  </div>
                  <v-text-field
                    v-model="form.password"
                    type="password"
                    placeholder="Your password"
                    variant="outlined"
                    density="comfortable"
                    required
                    hide-details
                    class="custom-input"
                    bg-color="white"
                  ></v-text-field>
                </div>

                <!-- Error Alert -->
                <v-alert
                  v-if="error"
                  type="error"
                  variant="tonal"
                  density="compact"
                  closable
                  class="mb-4 mt-4"
                  @click:close="error = ''"
                >
                  {{ error }}
                </v-alert>

                <!-- Keep me logged in -->
                <div class="mb-8 mt-6">
                  <v-checkbox
                    v-model="rememberMe"
                    label="Keep me logged in"
                    density="compact"
                    hide-details
                    class="custom-checkbox"
                  ></v-checkbox>
                </div>

                <!-- Sign in button -->
                <v-btn
                  type="submit"
                  block
                  size="x-large"
                  color="primary"
                  :loading="loading"
                  :disabled="loading"
                  class="signin-button mb-6 text-none"
                  elevation="0"
                  rounded="lg"
                >
                  Sign in
                </v-btn>

                <!-- Sign up link -->
                <div class="text-center">
                  <span class="text-body-2 text-grey-darken-1">Don't have an account? </span>
                  <a href="#" class="signup-link">Sign up now</a>
                </div>
              </v-form>
            </div>
          </v-col>

          <!-- Right Side - Image/Branding -->
          <v-col cols="12" md="7" class="d-none d-md-flex image-side">
            <div class="image-content">
                             <img src="~@/assets/images/logo-full.png" alt="Logo" class="logo-image" />

            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { login } from '@/services/auth'

const router = useRouter()
const redirectTarget = router.currentRoute.value.query?.redirect
const form = reactive({ email: '', password: '' })
const loading = ref(false)
const error = ref('')
const rememberMe = ref(false)
const formRef = ref(null)

// Random images from pravatar
const randomImages = computed(() => [
  `https://i.pravatar.cc/150?img=${Math.floor(Math.random() * 70) + 1}`,
  `https://i.pravatar.cc/150?img=${Math.floor(Math.random() * 70) + 1}`,
  `https://i.pravatar.cc/150?img=${Math.floor(Math.random() * 70) + 1}`
])

async function submit() {
  error.value = ''
  loading.value = true
  try {
    const res = await login({ email: form.email, password: form.password })
    if (redirectTarget) {
      router.replace(redirectTarget)
    } else {
      router.push('/')
    }
  } catch (err) {
    console.error(err)
    error.value = err.response?.data?.message || err.message || 'فشل تسجيل الدخول'
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  background: #ffffff;
}

/* Left Side - Form */
.login-form-side {
  background: #ffffff;
  padding: 48px;
}

.form-container {
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
}

.logo-section {
  display: flex;
  align-items: center;
}

.logo-image {
  max-height: 300px;
  width: auto;
}

.field-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.forgot-link {
  font-size: 14px;
  color: #5469d4;
  text-decoration: none;
  font-weight: 500;
}

.forgot-link:hover {
  text-decoration: underline;
}

.signup-link {
  color: #5469d4;
  text-decoration: none;
  font-weight: 600;
}

.signup-link:hover {
  text-decoration: underline;
}

.signin-button {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  height: 50px !important;
}

.custom-input :deep(.v-field) {
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
}

.custom-input :deep(.v-field__input) {
  padding: 12px 16px;
  font-size: 14px;
}

.custom-input :deep(.v-field--focused) {
  border-color: #5469d4;
}

.custom-checkbox :deep(.v-label) {
  font-size: 14px;
  color: #666;
}

/* Right Side - Image */
.image-side {
  background: linear-gradient(135deg, #e84545 0%, #301e1e 100%);
  position: relative;
  overflow: hidden;
}

.image-content {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Decorative circles */
.circle {
  position: absolute;
  border-radius: 50%;
  opacity: 0.9;
}

.circle-green {
  background: linear-gradient(135deg, #4db8a4 0%, #5cc9b5 100%);
}

.circle-blue {
  background: linear-gradient(135deg, #4a90e2 0%, #5ba3f5 100%);
}

.circle-red {
  background: linear-gradient(135deg, #e84545 0%, #f56565 100%);
}

.circle-yellow {
  background: linear-gradient(135deg, #d4a574 0%, #e0b886 100%);
}

.circle-1 {
  width: 280px;
  height: 280px;
  top: -80px;
  left: 60px;
}

.circle-2 {
  width: 350px;
  height: 350px;
  top: 15%;
  right: -80px;
}

.circle-3 {
  width: 450px;
  height: 450px;
  bottom: -120px;
  left: -60px;
}

.circle-4 {
  width: 200px;
  height: 200px;
  bottom: 15%;
  left: 20%;
}

.circle-5 {
  width: 80px;
  height: 80px;
  bottom: 35%;
  right: 18%;
}

/* Person images */
.person-image {
  position: absolute;
  border-radius: 50%;
  overflow: hidden;
  border: 4px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  z-index: 10;
}

.person-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.person-1 {
  width: 110px;
  height: 110px;
  top: 60px;
  right: 100px;
}

.person-2 {
  width: 180px;
  height: 180px;
  top: 40%;
  left: 15%;
  transform: translateY(-50%);
}

.person-3 {
  width: 100px;
  height: 100px;
  bottom: 120px;
  right: 120px;
}

/* Main message */
.main-message {
  position: relative;
  z-index: 20;
  text-align: center;
  max-width: 480px;
  padding: 40px;
}

/* Carousel dots */
.carousel-dots {
  position: absolute;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 20;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;
}

.dot.active {
  background: #ffffff;
  width: 24px;
  border-radius: 4px;
}

.dot:hover {
  background: rgba(255, 255, 255, 0.6);
}

/* Responsive */
@media (max-width: 960px) {
  .login-form-side {
    padding: 32px 24px;
  }
  
  .form-container {
    max-width: 100%;
  }
  
  .logo-section {
    justify-content: center;
  }
}
</style>
